exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex; \r\n    flex-direction: column; \r\n    height: 100vh;\r\n    width: 100%;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/framework-body/framework-body.component.css
// module id = 1853
// module chunks = 1